import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "accom-search availability" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "property-status__title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "property-status__title" }, "Search again", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "accom-search__item" }
const _hoisted_9 = { class: "accom-search__item" }
const _hoisted_10 = { class: "accom-search__item accom-search__item--submit" }
const _hoisted_11 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldDatePicker = _resolveComponent("FieldDatePicker")!
  const _component_FieldTotalSelector = _resolveComponent("FieldTotalSelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasSearch)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["accom-search__item property-status", _ctx.hasResult ? (_ctx.isAvailable ? 'available' : 'unavailable') : ''])
        }, [
          (_ctx.hasResult)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.isAvailable ? 'available' : 'unavailable'), 1),
                (_ctx.constraintMessage)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.constraintMessage), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_5, _hoisted_7))
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_FieldDatePicker, {
        label: "Check in / Check out",
        name: ['dateFrom', 'dateTo'],
        required: true,
        class: _normalizeClass(['dropdown', 'dropdown--placeholder']),
        value: _ctx.dates,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dates) = $event))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_FieldTotalSelector, {
        required: "",
        styles: ['guests'],
        name: "guestCount",
        label: "Guests",
        value: _ctx.guests,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.guests) = $event)),
        quantities: {
                adults: {
                    name: 'adults',
                    label: 'Adults',
                    title: 'Adult',
                    minimum: 1,
                    maximum: 16,
                },
                children: {
                    name: 'children',
                    label: 'Children',
                    title: 'Kid',
                    helper: '(2 - 17yrs)',
                    minimum: 0,
                    maximum: 16,
                },
            }
      }, null, 8, ["value", "quantities"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("input", {
        class: "button button-wide",
        type: "submit",
        value: _ctx.isAvailable ? 'Book now' : 'Check availability',
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
      }, null, 8, _hoisted_11)
    ])
  ]))
}